/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { getCommandIntelligenceTokens } from '../../../theme/commandIntelligenceTokens';

export const getCommandIntelligenceContextBarStyles = theme => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      width: '100%',
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
    },
    sectionLabelRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.75,
      minWidth: 0,
    },
    sectionIcon: {
      fontSize: '1rem',
      color: tokens.accentPrimary,
    },
    sectionLabel: {
      fontSize: '0.6875rem',
      fontWeight: 600,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: tokens.textMuted,
      fontFamily: tokens.fontStack,
    },
    clearButton: {
      textTransform: 'none',
      fontSize: '0.75rem',
      color: tokens.textMuted,
      minWidth: 0,
      px: 0.5,
      py: 0.25,
      flexShrink: 0,
      '&:hover': {
        color: tokens.textSecondary,
        bgcolor: 'transparent',
      },
    },
    chipsRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 0.75,
    },
    chip: {
      fontFamily: tokens.fontStack,
      fontSize: '0.8125rem',
      height: 28,
      borderRadius: tokens.radiusChip,
      bgcolor: tokens.surfaceContent,
      border: `1px solid ${tokens.borderSubtle}`,
      '& .MuiChip-deleteIcon': {
        fontSize: '1rem',
        color: tokens.textMuted,
      },
    },
    addButton: {
      alignSelf: 'flex-start',
      textTransform: 'none',
      fontFamily: tokens.fontStack,
      fontSize: '0.875rem',
      fontWeight: 500,
      borderRadius: tokens.radiusChip,
      borderColor: tokens.borderInput,
      color: tokens.accentPrimary,
      bgcolor: tokens.surfaceContent,
      px: 1.5,
      py: 0.75,
      '& .MuiButton-startIcon': {
        marginRight: 0.5,
        '& > svg': {
          fontSize: '1.125rem',
        },
      },
      '&:hover': {
        borderColor: tokens.accentPrimary,
        bgcolor: tokens.surfaceContent,
      },
      '&.Mui-disabled': {
        borderColor: tokens.borderSubtle,
        color: tokens.textMuted,
      },
    },
  };
};
